
import { Link } from "react-router-dom";

const SolMezclasId = () => {
  return (
    <Link to={'/profile/identificacion'} className="button-home">
      <img src={`${AZURE_BASE_URL}/button-id.webp`} className='w-full' />
    </Link>
  )
}

export default SolMezclasId

